import React from "react";
import LogoSVG from "../../assets/icons/logo.svg";
import { NotificationBell } from "../notifications/NotificationBell";

interface HeaderProps {
    userName?: string;
    onLogout?: () => void;
    taskCount?: number;
    onTaskClick?: () => void;
    onSearchClick?: () => void;
}

export const Header: React.FC<HeaderProps> = ({ userName, onLogout, taskCount, onTaskClick, onSearchClick }) => {
    return (
        <header
            style={{
                height: 60,
                backgroundColor: "#EBF5F5",
                borderBottom: "1px solid #B4D9D4",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "0 24px",
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                zIndex: 1000,
            }}
        >
            {/* Logo */}
            <div style={{ display: "flex", alignItems: "center" }}>
                <img
                    src={LogoSVG}
                    alt="PREDICTIX"
                    style={{ height: 32, width: "auto" }}
                />
            </div>

            {/* User Info */}
            <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
                {/* Patient search - opens the search popup from any screen */}
                {onSearchClick && (
                    <button
                        onClick={onSearchClick}
                        title="Search patients"
                        aria-label="Search patients"
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background: "transparent",
                            border: "none",
                            padding: 0,
                            cursor: "pointer",
                            color: "#374151",
                        }}
                    >
                        <svg
                            width="22"
                            height="22"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <circle cx="11" cy="11" r="7" />
                            <line x1="21" y1="21" x2="16.65" y2="16.65" />
                        </svg>
                    </button>
                )}
                {/* Real-time notification center (independent from task bell) */}
                <NotificationBell />
                {taskCount !== undefined && taskCount > 0 && (
                    <div
                        onClick={onTaskClick}
                        style={{ position: "relative", cursor: "pointer", display: "flex", alignItems: "center" }}
                        title="Tasks needing action"
                    >
                        <svg
                            width="22"
                            height="22"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#374151"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2" />
                            <rect x="9" y="3" width="6" height="4" rx="1" ry="1" />
                            <line x1="9" y1="12" x2="15" y2="12" />
                            <line x1="9" y1="16" x2="13" y2="16" />
                        </svg>
                        <span
                            style={{
                                position: "absolute",
                                top: -6,
                                right: -8,
                                backgroundColor: "#EF4444",
                                color: "#fff",
                                fontSize: 11,
                                fontWeight: 700,
                                minWidth: 18,
                                height: 18,
                                borderRadius: 9,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                padding: "0 4px",
                                lineHeight: 1,
                            }}
                        >
                            {taskCount}
                        </span>
                    </div>
                )}
                {userName && (
                    <span
                        style={{
                            fontSize: 14,
                            color: "#374151",
                            fontWeight: 500,
                        }}
                    >
                        {userName}
                    </span>
                )}
                {onLogout && (
                    <button
                        onClick={onLogout}
                        style={{
                            padding: "6px 12px",
                            fontSize: 14,
                            fontWeight: 500,
                            color: "#374151",
                            backgroundColor: "transparent",
                            border: "1px solid #d1d5db",
                            borderRadius: 6,
                            cursor: "pointer",
                            transition: "all 0.2s",
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = "#f3f4f6";
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = "transparent";
                        }}
                    >
                        Logout
                    </button>
                )}
            </div>
        </header>
    );
};
